import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, skipWhile, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const publicGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  return authService.getLoggedInUser().pipe(
    skipWhile(value => value === undefined), // Wait until auth state is resolved
    take(1),
    map((user) => {
      if (user) {
        // If user is logged in, redirect to dashboard
        return router.parseUrl('/dashboard');
      }
      // If user is not logged in, allow access to public route
      return true;
    })
  );
};
